const types = {
  SHOW_LOGIN_MODAL: "SHOW LOGIN MODAL",
  HIDE_LOGIN_MODAL: "HIDE LOGIN MODAL",
  SET_DETAILS: "SET DETAILS",
  LOGOUT: "LOGOUT",
};

export default types;
